import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

import { MapsAPILoader } from '@agm/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class SearchService {
  public foundedPlaces: BehaviorSubject<
    Array<google.maps.places.AutocompletePrediction>
  >;
  public foundedPlaces$: Observable<
    Array<google.maps.places.AutocompletePrediction>
  >;
  public foundedPlace: BehaviorSubject<google.maps.places.PlaceResult>;
  public foundedPlace$: Observable<google.maps.places.PlaceResult>;

  private places: Array<google.maps.places.AutocompletePrediction>;
  private place: google.maps.places.PlaceResult;
  private _placesService: google.maps.places.PlacesService;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private mapsAPILoader: MapsAPILoader,
  ) {
    this.places = [];
    this.foundedPlaces = new BehaviorSubject<
      Array<google.maps.places.AutocompletePrediction>
    >(this.places);
    this.foundedPlaces$ = this.foundedPlaces.asObservable();

    this.place = null;
    this.foundedPlace = new BehaviorSubject<google.maps.places.PlaceResult>(
      this.place,
    );
    this.foundedPlace$ = this.foundedPlace.asObservable();

    this.mapsAPILoader.load().then(() => {
      const div = this.document.createElement('div');
      this._placesService = new google.maps.places.PlacesService(
        div as HTMLDivElement,
      );
    });
  }

  public search(inputText: string): void {
    this.getPlacePredictions(inputText)
      .then(data => {
        this.displayFoundedPlaces(data);
      })
      .catch(error => console.log(error));
  }

  public placeDetail(id: string): void {
    this.getPlaceDetails(id)
      .then(data => {
        this.displayFoundedPlace(data);
      })
      .catch(error => console.log(error));
  }

  public displayFoundedPlaces(
    places: Array<google.maps.places.AutocompletePrediction>,
  ): void {
    this.foundedPlaces.next(places);
  }

  public displayFoundedPlace(place: google.maps.places.PlaceResult): void {
    this.foundedPlace.next(place);
  }

  private getPlacePredictions(query: string): Promise<any> {
    const autoCompleteSrv = new google.maps.places.AutocompleteService();
    return new Promise((resolve, reject) => {
      autoCompleteSrv.getPlacePredictions(
        {
          input: query,
          componentRestrictions: { country: 'US' },
        },
        (predictions, status) => {
          if (status === google.maps.places.PlacesServiceStatus.OK) {
            resolve(predictions);
          } else {
            reject(status);
          }
        },
      );
    });
  }

  private getPlaceDetails(query: string): Promise<any> {
    const detailsReq = { placeId: query };
    const div = this.document.createElement('div');
    const placesService = new google.maps.places.PlacesService(
      div as HTMLDivElement,
    );
    return new Promise((resolve, reject) => {
      placesService.getDetails(
        detailsReq,
        (detailResult: google.maps.places.PlaceResult, status) => {
          if (status === google.maps.places.PlacesServiceStatus.OK) {
            resolve(detailResult);
          } else {
            reject(status);
          }
        },
      );
    });
  }
}
